import { CSSProperties } from 'react';

import { RootState } from '@/store/main';
import { EPanelDirections, EPreviewSize, GridItemState } from './types';
import { EPaletteModes } from '@/types/theme-packs.types';

export const selectLayoutDirection = (state: RootState): EPanelDirections => state.layoutGrid.direction;
export const selectPanelOpen = (state: RootState): GridItemState => state.layoutGrid.panelOpen;
export const selectOppositePanelOpen = (state: RootState): GridItemState => state.layoutGrid.oppositePanelOpen;
export const selectFooterOpen = (state: RootState): GridItemState => state.layoutGrid.footerOpen;
export const selectPillarOpen = (state: RootState): GridItemState => state.layoutGrid.pillarOpen;
export const selectHeaderOpen = (state: RootState): GridItemState => state.layoutGrid.headerOpen;
export const selectPreviewSize = (state: RootState): EPreviewSize => state.layoutGrid.previewSize;
export const selectLTRGridLayout = (state: RootState): CSSProperties['gridTemplateAreas'] =>
  state.layoutGrid.gridLayoutLTR;
export const selectRTLGridLayout = (state: RootState): CSSProperties['gridTemplateAreas'] =>
  state.layoutGrid.gridLayoutRTL;
export const selectBodyAttributesTheme = (state: RootState): EPaletteModes => state.layoutGrid.bodyAttributes.theme;
